import { AxiosError } from 'axios'

import { type HttpClientError } from 'core/infra/http/HttpClient'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import {
  ShipmentChargesRepository,
  type PostShipmentChargeParams,
} from '../infra/ShipmentChargesRepository'

const DEFAULT_ERROR_MESSAGE = "Sorry, we're not able to create the charge. Please try again."

export type CreateShipmentChargeDependencies = {
  repository: ShipmentChargesRepository
}

export function createShipmentChargeFactory({ repository }: CreateShipmentChargeDependencies) {
  return async function postShipmentCharge({
    shipmentUUID,
    newCharge,
    config,
  }: PostShipmentChargeParams) {
    try {
      const createdCharge = await repository.postShipmentCharge({ shipmentUUID, newCharge, config })

      return createdCharge
    } catch (error) {
      let errorMessage = DEFAULT_ERROR_MESSAGE

      if (error instanceof AxiosError) {
        const axiosError = error as HttpClientError<{ error?: string }>

        errorMessage = axiosError?.response?.data?.error || DEFAULT_ERROR_MESSAGE
      }

      throw errorMessage
    }
  }
}

export function createShipmentCharge({
  shipmentUUID,
  newCharge,
  config,
}: PostShipmentChargeParams) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentChargesRepository({ httpClient })
  const postShipmentCharge = createShipmentChargeFactory({ repository })

  return postShipmentCharge({ shipmentUUID, newCharge, config })
}
